/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 留资
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class VisitingcardController<T = any> extends BasesController<T> {
    constructor() {
        super();
        this.reset({
            dataKey: 'id',
            infinite: true,
            // pagination: EnumAPI.content_isg_retaincapital_list,
            // details: EnumAPI.usersvr_bizNews_details,
            // paginationParams: {
            //     currentKey: 'curPageNo',
            //     pageSizeKey: 'pageSize',
            //     filterKey: 'search',
            //     response: {
            //         dataSource: 'recordList',
            //         total: 'recordCount',
            //         // valueGetter: this.valueGetter,
            //     }
            // },
        })
    }

    /**
     * 值存储
     * @memberof VisitingcardController
     */
    Model = new BaseModel({ type: 'object' })

    /**
     * @dec 名片开通状态
     */
    @computed
    get isOpen() {
        const status = this.Model.get('info.businessCardStatus')
        return lodash.eq(status, '1') || lodash.eq(status, 1)
        // return true
    }

    /**
     * @dec 名片信息
     */
    @computed
    get cardInfo() {
        return this.Model.get("info", {});
    }

    getUserTypeName(userType) {
        return lodash.get({
            "inboundsales": "内部销售",
            "outboundsales": "外部销售",
            "channel": "渠道"
        }, userType, '')
    }

    /**
     * 获取名片信息
     */
    async getCardInfo() {
        try {
            const res = await AjaxBasics.request({ ...EnumAPI.content_isg_card_get_info })
            this.Model.merge({ info: res })
        } catch (error) {
        }
    }

    /**
     * 修改名片信息
     */
    async updateCardInfo(body) {
        try {
            await AjaxBasics.request({ ...EnumAPI.content_isg_card_save_info, body: lodash.pick(body, ["personPhoto", "weChatQrCode", "email"]) })
        } catch (error) { }
    }

    /**
     * 关闭名片
     */
    async closeCardInfo() {
        try {
            await AjaxBasics.request({ ...EnumAPI.content_isg_card_close_info })
        } catch (error) { }
    }

    /**
     * 第三方查看名片
     */
    async getThirdCardInfo(promoCode) {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.content_isg_card_third_info,
                headers: { 'promo-code': promoCode }
            })
            this.Model.merge({ info: res })
        } catch (error) { }
    }
}
